
import { Vue, Options } from "vue-class-component";
import {
  UrgentDeliveryApiList,
  UrgentDeliveryData,
  RequestUrgentDeliveryListApi,
  UrgentDeliveryDetail,
  UrgentDeliveryDetailData,
  RequestUrgentDeliveryListApiDownload
} from "@/domain/entities/UrgentDelivery";
import { UrgentDeliveryController } from "@/app/ui/controllers/UrgentDeliveryController";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { ApiStateData } from "@/domain/entities/Api";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import formatDateNumber from "@/app/infrastructures/misc/common-library/FormatDateNumber";
import { ErrorMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import Detail from "./components/detail.vue";
import UploadFileUrgentDelivery from "./components/upload-file-urgent-deilvery/index.vue";
import { RequestPriorityDeliveryController } from "../../controllers/RequestPriorityDeliveryController";
import { MainAppController } from "../../controllers/MainAppController";
import {
  CancelRequestPriorityDelivery,
  CreateRequestPriorityDelivery,
  RequestPriorityDelivery
} from "@/domain/entities/RequestPriorityDelivery";
import RadioButton from "primevue/radiobutton";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { AccountController } from "../../controllers/AccountController";
import { FlagPermissionUrgentDeliveryRequests } from "@/feature-flags/flag-permission-urgent-delivery-requests";
import formatPrice from "@/app/infrastructures/misc/common-library/FormatPrice";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import { FlagsPermissionUrgentDelivery } from "@/feature-flags/flag-config-urgent-delivery";
import { KIRIMAN_PENTING, DELIVERY_ULANG, RTS, HAL } from "./urgent-delivery";
import { getCountryScopeParam } from "@/app/infrastructures/misc/CountryScope";

@Options({
  components: {
    UploadFileUrgentDelivery,
    RadioButton,
    Detail
  }
})
export default class UrgentDelivery extends Vue {
  showModalRequestUrgentDelivery = false;
  mounted() {
    if (this.isPosAccount) {
      this.filter.requestType = new OptionsClass({
        name: "HAL",
        value: "HAL"
      });
      this.filter.requestBy = new OptionsClass({
        name: "POS",
        value: "pos"
      });
    }
    this.fetchData();
    this.fetchSTTStatusData();
  }
  get getTitle() {
    return this.$route.meta.title;
  }
  get isPosAccount() {
    return AccountController.accountData.isPosAccount;
  }

  apiListData = new ApiStateData();
  apiDetailData = new ApiStateData();
  urgentDeliveryDetailData = new UrgentDeliveryDetailData();
  urgentDeliveryApiList = new UrgentDeliveryApiList();

  lastStatusData: OptionsClass[] = [];

  firstPagination() {
    this.urgentDeliveryApiList.response.pagination.page = 1;
  }
  async fetchData() {
    try {
      this.apiListData.loading = true;
      this.urgentDeliveryApiList.response = await UrgentDeliveryController.getUrgentDeliveryList(
        new RequestUrgentDeliveryListApi({
          page: this.urgentDeliveryApiList.response.pagination.page,
          limit: this.urgentDeliveryApiList.response.pagination.limit,
          sttNo: this.filter.search,
          startDate: formatDateNumber(this.filter.startDate),
          endDate: formatDateNumber(this.filter.endDate),
          requestType: this.filter.requestType.value,
          lastStatus: this.filter.lastStatus.value,
          requestStatus: this.filter.requestStatus.value,
          requestBy: this.filter.requestBy.value,
          orderBy: this.filter.orderBy,
          sortBy: this.filter.sortBy,
          countryCode: getCountryScopeParam(),
        })
      );
      this.apiListData.errorType = "";
    } catch (error) {
      this.apiListData.errorType = parsingErrorResponse(error).type;
    } finally {
      this.apiListData.loading = false;
    }
  }
  async getDetailData(id: number) {
    MainAppController.showLoading();
    try {
      this.urgentDeliveryDetailData = await UrgentDeliveryController.getUrgentDeliveryDetail(
        {
          id,
          countryCode: getCountryScopeParam()
        }
      );
      this.modalDetail = true;
      this.apiDetailData.errorType = "";
    } catch (error) {
      MainAppController.closeLoading();
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: this.$t("requestHal.failedGetDetail"),
          onClose: () => {
            MainAppController.closeErrorMessage();
          }
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  async fetchSTTStatusData() {
    const resp = await UrgentDeliveryController.getUrgentDeliverySTTStatusList();
    this.lastStatusData = resp.data.map(
      (status) =>
        new OptionsClass({
          name: status.name,
          value: status.name
        })
    );
  }
  get isEmpty() {
    return (
      !this.urgentDeliveryApiList.response.data.length &&
      !this.apiListData.loading
    );
  }

  get columns() {
    if (this.isPosAccount) {
      return [
        ...this.columnsOne,
        ...this.columnsTwo,
        ...this.columnsThree,
        ...this.columnAction
      ];
    } else {
      return [...this.columnsOne, ...this.columnsTwo, ...this.columnsThree];
    }
  }

  get columnsOne() {
    return [
      {
        name: this.$t("requestHal.number"),
        styleHead: "w-16 text-left",
        render: (item: UrgentDeliveryData, index: number) => {
          return `<div class="text-black-lp-300">${index +
            1 +
            this.urgentDeliveryApiList.response.pagination.limit *
              (this.urgentDeliveryApiList.response.pagination.page - 1)}</div>`;
        }
      },
      {
        name: this.$t("requestHal.sttNumber"),
        styleHead: "w-48 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${item.rpdSttNo}</div>`;
        }
      },
      {
        name: this.$t("requestHal.requestType"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${item.rpdRequestType}</div>`;
        }
      },
      {
        name: this.$t("requestHal.reason"),
        styleHead: "w-52 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${item.rpdReason}</div>`;
        }
      }
    ];
  }

  get columnsTwo() {
    return [
      {
        name: this.$t("requestHal.deadline"),
        styleHead: "w-48 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class='text-black-lp-300  flex flex-row'>
                ${item.formatDeadline}
                </div>`;
        }
      },
      {
        name: this.$t("requestHal.destination"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${item.sttDestinationCity}</div>`;
        }
      },
      {
        name: this.$t("requestHal.lastStatus"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${item.sttLastStatusId}</div>`;
        }
      },
      {
        name: this.$t("requestHal.requestBy"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300">${this.formatRequestByData(
            item.rpdRequestBy
          )}</div>`;
        }
      }
    ];
  }

  get columnsThree() {
    return [
      {
        name: this.$t("requestHal.requestStatus"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300 flex">
                    <div class="${
                      this.mapRequestStatusData(item.rpdRequestStatus).style
                    }">
                        ${this.mapRequestStatusData(item.rpdRequestStatus).text}
                    </div>
                  </div>`;
        }
      },
      {
        name: this.$t("requestHal.createdAt"),
        styleHead: "w-60 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300 break-all">${formatDate(
            item.formatCreatedAt
          )}</div>
          <div class="capitalize text-gray-lp-500 break-all">${ellipsisString(
            item.rpdCreatedBy || "-",
            20
          )}</div>`;
        }
      },
      {
        name: this.$t("requestHal.updatedAt"),
        styleHead: "w-60 text-left",
        render: (item: UrgentDeliveryData) => {
          return `<div class="text-black-lp-300 break-all">${
            item.formatUpdatedAt
          }</div>
          <div class="capitalize text-gray-lp-500 break-all">${ellipsisString(
            item.rpdUpdatedBy || "-",
            20
          )}</div>`;
        }
      }
    ];
  }

  get columnAction() {
    return [
      {
        name: "Action",
        key: "button_column",
        styleHead: "w-50 text-left",
        styleButton: (item: UrgentDeliveryData) => {
          return {
            outline: true,
            title: this.$t("requestHal.cancel"),
            textColor: "gray-lp-300",
            color: "gray-lp-600",
            class: "text-center",
            small: false,
            disabled: !item.rpdIsAllowCancel,
            clickFunction: () => this.openCancelModal(item.rpdId)
          };
        }
      }
    ];
  }

  filter = {
    search: "",
    startDate: "",
    endDate: "",
    requestType: new OptionsClass(),
    lastStatus: new OptionsClass(),
    requestStatus: new OptionsClass(),
    requestBy: new OptionsClass(),
    orderBy: "",
    sortBy: "desc"
  };
  get sumFilter(): number {
    return (
      (!this.isPosAccount && this.filter.requestType.value ? 1 : 0) +
      (this.filter.lastStatus.value ? 1 : 0) +
      (this.filter.requestStatus.value ? 1 : 0) +
      (!this.isPosAccount && this.filter.requestBy.value ? 1 : 0)
    );
  }
  //advanced filter
  isAdvancedFilterOpened = false;
  onOpenedAdvancedFilter(event: any) {
    this.isAdvancedFilterOpened = event;
  }
  onChangeAdvancedFilter() {
    this.firstPagination();
    this.fetchData();
  }
  async onResetAdvancedFilter() {
    this.apiListData.loading = true;
    Object.assign(this.filter, {
      requestType: this.isPosAccount
        ? new OptionsClass({
            name: "HAL",
            value: "HAL"
          })
        : new OptionsClass(),
      lastStatus: new OptionsClass(),
      requestStatus: new OptionsClass(),
      requestBy: this.isPosAccount
        ? new OptionsClass({
            name: "POS",
            value: "pos"
          })
        : new OptionsClass()
    });

    this.firstPagination();
    await this.fetchData();
  }
  // filter search
  onSearch(value: string) {
    if (!value.length || value.length >= 3) {
      // this.urgentDeliveryApiList.request.search = value;
      this.filter.search = value;
      this.firstPagination();
      this.fetchData();
      this.isFiltered = true;
    }
  }
  // date
  isFiltered = false;
  countDatePicker = 0;
  setDateRange(value: any[]) {
    this.countDatePicker++;
    this.filter.startDate = value[0];
    this.filter.endDate = value[1];

    if (value[0] && value[1]) {
      if (this.countDatePicker > 1) {
        this.isFiltered = true;
      }
      this.firstPagination();
      this.fetchData();
    }
  }
  // requestType
  get requestTypeData(): OptionsClass[] {
    return [
      new OptionsClass({
        name: this.$t("requestHal.all"),
        value: ""
      }),
      new OptionsClass({
        name: this.$t("requestHal.importantShipment"),
        value: "Kiriman Penting"
      }),
      new OptionsClass({
        name: this.$t("requestHal.redelivery"),
        value: "Delivery Ulang"
      }),
      new OptionsClass({
        name: "RTS",
        value: "RTS"
      }),
      new OptionsClass({
        name: "HAL",
        value: "HAL"
      })
    ];
  }
  selectRequestType(data: OptionsClass) {
    Object.assign(this.filter, { requestType: data });
    this.onChangeAdvancedFilter();
    this.isFiltered = true;
  }

  selectLastStatus(data: OptionsClass) {
    Object.assign(this.filter, { lastStatus: data });
    this.onChangeAdvancedFilter();
    this.isFiltered = true;
  }

  // requestType
  get requestStatusData(): OptionsClass[] {
    return [
      new OptionsClass({
        name: this.$t("requestHal.success"),
        value: "success"
      }),
      new OptionsClass({
        name: this.$t("requestHal.cancelled"),
        value: "canceled"
      })
    ];
  }
  selectRequestStatus(data: OptionsClass) {
    Object.assign(this.filter, { requestStatus: data });
    this.onChangeAdvancedFilter();
    this.isFiltered = true;
  }

  // requestBy
  get requestByData(): OptionsClass[] {
    return [
      new OptionsClass({
        name: this.$t("requestHal.all"),
        value: ""
      }),
      new OptionsClass({
        name: "POS",
        value: "pos"
      }),
      new OptionsClass({
        name: "Internal",
        value: "internal"
      })
    ];
  }
  selectRequestBy(data: OptionsClass) {
    Object.assign(this.filter, { requestBy: data });
    this.onChangeAdvancedFilter();
    this.isFiltered = true;
  }

  //toggle button
  isToggleSortButtonActive = false;

  toggleSortButton() {
    this.isToggleSortButtonActive = !this.isToggleSortButtonActive;
    this.isToggleSortButtonActive
      ? (this.filter.sortBy = "asc")
      : (this.filter.sortBy = "desc");
    this.firstPagination();
    this.fetchData();
  }

  get getActiveSortButton() {
    return this.isToggleSortButtonActive
      ? {
          textColor: "red-lp-300",
          borderColor: "red-lp-300",
          customClass: "w-40 mr-4 btn-active"
        }
      : {
          textColor: "gray-lp-500",
          borderColor: "",
          customClass: "w-40 mr-4"
        };
  }

  async onDownload() {
    await UrgentDeliveryController.getUrgentDeliverySTTDownload(
      new RequestUrgentDeliveryListApiDownload({
          sttNo: this.filter.search,
          startDate: formatDateNumber(this.filter.startDate),
          endDate: formatDateNumber(this.filter.endDate),
          requestType: this.filter.requestType.value,
          lastStatus: this.filter.lastStatus.value,
          orderBy: this.filter.orderBy,
          sortBy: this.filter.sortBy,
          countryCode: getCountryScopeParam(),
        })
    );
  }

  modalDetail = false;
  async goToDetail(item: UrgentDeliveryData) {
    await this.getDetailData(item.rpdId);
  }
  closeDetail() {
    this.modalDetail = false;
  }
  form = {
    sttNo: "",
    requestType: "",
    reasonType: "" as any,
    remarks: "",
    links: [] as OptionsClass[]
  };
  linkOptions = [];
  detailSTT = new RequestPriorityDelivery({});
  error = {
    sttNo: false,
    captionError: ""
  };

  get isDisabled() {
    return (
      this.form.sttNo.length < 17 ||
      !this.form.requestType ||
      !this.form.reasonType ||
      !this.form.remarks ||
      this.error.sttNo
    );
  }
  get attachments() {
    return RequestPriorityDeliveryController.attachments.map(
      (key: any) => key.source
    );
  }
  onBlurSttNo() {
    if (this.form.sttNo.length < 17) {
      this.error.sttNo = true;
      this.error.captionError = this.$t("requestHal.invalidSttNumber");
    }
    // to do on blur
  }
  onInputSttNo() {
    if (this.form.sttNo.length === 17) this.getDetailSttNo();
    // to do on input
  }
  onChangeSttNo() {
    this.error.sttNo = false;
    this.error.captionError = "";
    if (this.isPosAccount) {
      this.requestTypes[3].disabled = false;
    } else {
      this.requestTypes.forEach((element: any) => {
        element.disabled = false;
      });
    }
    this.detailSTT = new RequestPriorityDelivery({});
  }
  get isDEXOrCODREJ() {
    return (
      this.detailSTT.sttLastStatusId === "DEX" ||
      this.detailSTT.sttLastStatusId === "CODREJ"
    );
  }
  onChangeRadioButton() {
    if (this.form.requestType === "Delivery Ulang" && this.isDEXOrCODREJ) {
      this.form.reasonType = this.detailSTT.deliveryReasonTitle;
    } else if (
      this.form.requestType === "Delivery Ulang" &&
      this.detailSTT.sttLastStatusId === "HAL"
    ) {
      this.form.reasonType = this.$t("requestHal.reasonHoldAtHub");
    } else {
      this.form.reasonType =
        this.form.requestType === "RTS" && !this.isDEXOrCODREJ
          ? this.$t("requestHal.reasonReturnCustomer")
          : "";
    }
    this.showPenaltyMessage =
      this.form.requestType === "HAL" && this.isPosAccount;
  }
  async getDetailSttNo() {
    try {
      MainAppController.showLoading();
      const resp = await RequestPriorityDeliveryController.getDetailRpd(
        this.form.sttNo
      );
      this.detailSTT = resp;
      this.onCheckDetailSTT(this.detailSTT.sttLastStatusId); // check last status eligible or not for validate input sttno
      // check product type jumbopackh2h
      if (this.detailSTT.sttProductType.toUpperCase() === "JUMBOPACKH2H") {
        this.error.sttNo = true;
        this.error.captionError = this.$t("requestHal.jumboPackPickup");
      }
      this.onSetDisableOptionRequestType(); //disabled option by last status eligble or not
      this.onResetDataDisabled();
    } catch (error) {
      this.error.sttNo = true;
      this.error.captionError = this.$t("requestHal.invalidSttNumber");
    } finally {
      MainAppController.closeLoading();
      MainAppController.closeErrorMessage();
    }
  }
  onCheckDetailSTT(lastStatus: string) {
    const ALL_STATUS = [
      ...this.configEligibleUrgentDelivery,
      ...this.configEligibleDeliveryUlang,
      ...this.configEligibleRts,
      ...this.configEligibleHal
    ];
    const filterSTT = ALL_STATUS.filter(
      (key) => key.includes(lastStatus) || key === lastStatus
    );
    if (!filterSTT.length) {
      this.error.sttNo = true;
      this.error.captionError = this.$t("requestHal.invalidSttNumber");
    }
  }
  onSetDisableOptionRequestType() {
    this.requestTypes[0].disabled = this.disabledOptionKirimanPenting;
    this.requestTypes[1].disabled = this.disabledOptionDeliveryUlang;
    this.requestTypes[2].disabled = this.disabledOptionRTS;
    this.requestTypes[3].disabled = this.disabledOptionHAL;
  }
  get disabledOptionKirimanPenting() {
    const result = [...this.configEligibleUrgentDelivery].filter(
      (key) =>
        key.includes(this.detailSTT.sttLastStatusId) ||
        key === this.detailSTT.sttLastStatusId
    );
    const requestTypeDisable =
      this.detailSTT.rpdRequestType.length &&
      !this.requestTypeDisableRule.includes(KIRIMAN_PENTING);
    return (
      (this.detailSTT.sttLastStatusId.length && !result.length) ||
      requestTypeDisable ||
      this.isPosAccount
    );
  }
  get disabledOptionDeliveryUlang() {
    const result = [...this.configEligibleDeliveryUlang].filter(
      (key) =>
        key.includes(this.detailSTT.sttLastStatusId) ||
        key === this.detailSTT.sttLastStatusId
    );
    const requestTypeDisable =
      this.detailSTT.rpdRequestType.length &&
      !this.requestTypeDisableRule.includes(DELIVERY_ULANG);
    return (
      (this.detailSTT.sttLastStatusId.length && !result.length) ||
      requestTypeDisable ||
      this.isPosAccount
    );
  }
  get disabledOptionRTS() {
    const result = [...this.configEligibleRts].filter(
      (key) =>
        key.includes(this.detailSTT.sttLastStatusId) ||
        key === this.detailSTT.sttLastStatusId
    );
    const requestTypeDisable =
      this.detailSTT.rpdRequestType.length &&
      !this.requestTypeDisableRule.includes(RTS);
    return (
      (this.detailSTT.sttLastStatusId.length && !result.length) ||
      requestTypeDisable ||
      this.isPosAccount
    );
  }
  get disabledOptionHAL() {
    const result = [...this.configEligibleHal].filter(
      (key) =>
        key.includes(this.detailSTT.sttLastStatusId) ||
        key === this.detailSTT.sttLastStatusId
    );
    const requestTypeDisable =
      this.detailSTT.rpdRequestType.length &&
      !this.requestTypeDisableRule.includes(HAL);
    return (
      (this.detailSTT.sttLastStatusId.length && !result.length) ||
      requestTypeDisable
    );
  }

  onResetDataDisabled() {
    const selected = this.requestTypes.find(
      (item: any) => item.value === this.form.requestType
    );

    if (selected?.disabled) {
      this.form.requestType = "";
      this.form.reasonType = "";
    }
  }

  async onSave() {
    try {
      MainAppController.showLoading();
      MainAppController.closeErrorMessage();
      const isEligible =
        this.detailSTT.isSttRetail && this.detailSTT.bookedBy == this.getPosId;
      if (this.isPosAccount && !isEligible) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "circle-error",
            title: this.$t("requestHal.retailOnly"),
            message: this.$t("requestHal.invalidRetailStt", {
              stt: this.form.sttNo
            }),
            textSuccess: this.$t("requestHal.ok"),
            onSubmit: () => {
              MainAppController.closeMessageModal();
              this.firstPagination();
              this.fetchData();
            }
          })
        );
        return;
      }
      const resp = await RequestPriorityDeliveryController.createRpd(
        new CreateRequestPriorityDelivery({
          rpdSttNo: this.form.sttNo,
          rpdRequestType: this.form.requestType,
          rpdReason: this.form.reasonType,
          rpdProofPhoto: this.attachments,
          rpdNotes: this.form.remarks,
          rpdLink: this.form.links.map((e) => e.name)
        })
      );
      this.onShowModalRequestUrgentDelivery();
      this.filter = {
        search: "",
        startDate: "",
        endDate: "",
        requestType: new OptionsClass(),
        lastStatus: new OptionsClass(),
        requestStatus: new OptionsClass(),
        requestBy: new OptionsClass(),
        orderBy: "",
        sortBy: "desc"
      };
      this.isToggleSortButtonActive = false;
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "image-modal-success",
          title: this.$t("requestHal.requestCreated"),
          message: this.$t("requestHal.requestCreatedMessage", {
            stt: resp.sttNumber
          }),
          textSuccess: "Oke",
          onSubmit: () => {
            MainAppController.closeMessageModal();
            this.firstPagination();
            this.fetchData();
          }
        })
      );
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          err,
          this.$t("requestHal.requestCreateFailed"),
          () => this.onSave()
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  get requestTypes(): any {
    return [
      {
        name: this.$t("requestHal.importantShipment"),
        value: "Kiriman Penting",
        disabled: false
      },
      {
        name: this.$t("requestHal.redelivery"),
        value: "Delivery Ulang",
        disabled: false
      },
      { name: "RTS", value: "RTS", disabled: false },
      { name: "HAL", value: "HAL", disabled: false }
    ];
  }

  captionSTT = {
    isWarning: false,
    isError: false,
    caption: ""
  };
  get showSelectTypes() {
    return (
      this.form.requestType === "Kiriman Penting" ||
      this.form.requestType === "HAL" ||
      (this.form.requestType === "RTS" &&
        (this.detailSTT.sttLastStatusId === "DEX" ||
          this.detailSTT.sttLastStatusId === "CODREJ"))
    );
  }
  get reasonTypes() {
    let result: any[] = [];
    switch (this.form.requestType) {
      case "Kiriman Penting":
        result = this.reasonTypeKirimanPenting;
        break;
      case "HAL":
        result = this.reasonTypeHal;
        break;
      case "RTS":
        result = [
          ...this.reasonTypeRTS,
          {
            name: this.detailSTT.deliveryReasonTitle,
            value: this.detailSTT.deliveryReasonTitle
          },
          {
            name: this.$t("requestHal.returnRequestCustomer"),
            value: "Permintaan retur dari customer"
          }
        ];
        break;
      default:
        result = [
          {
            name: this.$t("requestHal.selectReason"),
            value: ""
          }
        ];
        break;
    }
    return result;
  }
  get reasonTypeKirimanPenting() {
    return [
      {
        name: this.$t("requestHal.selectReason"),
        value: ""
      },
      {
        name: this.$t("requestHal.specialEvent"),
        value: "Acara Khusus"
      },
      {
        name: this.$t("requestHal.food"),
        value: "Makanan"
      },
      {
        name: this.$t("requestHal.medicineShipment"),
        value: "Kiriman Obat"
      },
      {
        name: this.$t("requestHal.livePlants"),
        value: "Tanaman Hidup"
      }
    ];
  }
  get reasonTypeHal() {
    return [
      {
        name: this.$t("requestHal.selectReason"),
        value: ""
      },
      {
        name: this.$t("requestHal.doubleStt"),
        value: this.$t("requestHal.doubleStt")
      },
      {
        name: this.$t("requestHal.lessPackage"),
        value: this.$t("requestHal.lessPackage")
      },
      {
        name: this.$t("requestHal.receiverPickup"),
        value: this.$t("requestHal.receiverPickup")
      },
      {
        name: this.$t("requestHal.senderUnderpaid"),
        value: this.$t("requestHal.senderUnderpaid")
      },
      {
        name: this.$t("requestHal.changeAddressRequest"),
        value: this.$t("requestHal.changeAddressRequest")
      },
      {
        name: this.$t("requestHal.returnRequestCustomer"),
        value: this.$t("requestHal.returnRequestCustomer")
      }
    ];
  }
  get reasonTypeRTS() {
    return [
      {
        name: this.$t("requestHal.selectReason"),
        value: ""
      }
    ];
  }
  onShowModalRequestUrgentDelivery() {
    this.showModalRequestUrgentDelivery = !this.showModalRequestUrgentDelivery;
    this.onResetForm();
    this.disableRequestTypeInPosAccount();
    this.showPenaltyMessage = false;
  }
  onResetForm() {
    RequestPriorityDeliveryController.deleteAttachment([]);
    this.form = {
      sttNo: "",
      requestType: "",
      reasonType: "",
      remarks: "",
      links: []
    };
    this.linkOptions = [];
    this.error.sttNo = false;
    this.error.captionError = "";
    this.requestTypes.forEach((element: any) => {
      element.disabled = false;
    });
    this.detailSTT = new RequestPriorityDelivery({});
  }
  isOpenSelectReasonTypes = false;
  onOpenSelectReasonTypes() {
    this.isOpenSelectReasonTypes = true;
  }
  onCloseSelectReasonTypes() {
    this.isOpenSelectReasonTypes = false;
  }
  onSelectReasonTypes(_: string, value: string) {
    this.onCloseSelectReasonTypes();
    this.form.reasonType = value;
  }
  formatRequestByData(data: string) {
    switch (data) {
      case "pos":
        return "POS";
      case "internal":
        return "Internal";
      default:
        return "-";
    }
  }
  mapRequestStatusData(status: string) {
    let data = { style: "", text: "" };
    switch (status) {
      case "success":
        data = {
          text: this.$t("requestHal.success"),
          style:
            "rounded-2xl capitalize px-2 py-0 bg-green-lp-300 text-green-lp-400"
        };
        break;
      case "canceled":
        data = {
          text: this.$t("requestHal.cancelled"),
          style:
            "rounded-2xl capitalize px-2 py-0 bg-red-lp-600 text-red-lp-1500"
        };
        break;
      default:
        data = {
          text: "-",
          style: ""
        };
        break;
    }
    return data;
  }

  cancelId = 0;
  openModalcancel = false;

  openCancelModal(id: number) {
    this.cancelId = id;
    this.setOpenModalCancel(true);
  }

  setOpenModalCancel(open: boolean) {
    this.openModalcancel = open;
  }

  handlerCancel() {
    this.setOpenModalCancel(false);
    this._onCancel();
  }

  onCloseModalCancel() {
    this.setOpenModalCancel(false);
  }

  onCloseSuccess() {
    MainAppController.closeMessageModal();
    this.apiListData.loading = true;
    this.fetchData();
  }

  async _onCancel() {
    MainAppController.showLoading();
    try {
      await RequestPriorityDeliveryController.cancelRpd(
        new CancelRequestPriorityDelivery({
          rpdId: this.cancelId
        })
      );
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-success",
          title: this.$t("requestHal.cancelSuccess"),
          message: this.$t("requestHal.cancelHalSuccessMessage"),
          textSuccess: "OK",
          onSubmit: this.onCloseSuccess
        })
      );
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, this.$t("requestHal.cancelFailed"), () => {
          MainAppController.closeErrorMessage();
          this.openCancelModal(this.cancelId);
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  showPenaltyMessage = false;

  get getConfigPosPenalty() {
    return JSON.parse(
      FlagPermissionUrgentDeliveryRequests.config_pos_penalty.getValue()
    );
  }

  disableRequestTypeInPosAccount() {
    this.requestTypes[0].disabled = this.isPosAccount;
    this.requestTypes[1].disabled = this.isPosAccount;
    this.requestTypes[2].disabled = this.isPosAccount;
  }

  get getPenaltyMessage() {
    const config = this.getConfigPosPenalty;

    if (config.type === "percentage") {
      if (AccountController.accountData.accountIsForeign) {
        return `POS will receive a penalty of ${config.amount}% of the shipping fee`;
      } else {
        return this.$t("requestHal.posPenaltyMessagePercentage", {
          amount: config.amount,
          min: formatByCountry(config.min, { type: "money" }),
          max: formatByCountry(config.max, { type: "money" })
        });
      }
    }

    if (config.type === "flat") {
      return this.$t("requestHal.posPenaltyMessageFlat", {
        amount: formatByCountry(config.amount, { type: "money" })
      });
    }

    return "";
  }

  get getPosId() {
    return AccountController.accountData.account_type_detail.id;
  }

  get configEligibleUrgentDelivery() {
    return FlagsPermissionUrgentDelivery.config_eligible_urgent_delivery.getValue() as string[];
  }

  get configEligibleDeliveryUlang() {
    return FlagsPermissionUrgentDelivery.config_eligible_delivery_ulang.getValue() as string[];
  }

  get configEligibleRts() {
    return FlagsPermissionUrgentDelivery.config_eligible_rts.getValue() as string[];
  }

  get configEligibleHal() {
    return FlagsPermissionUrgentDelivery.config_eligible_hal.getValue() as string[];
  }

  get configEligibleOverride() {
    return FlagsPermissionUrgentDelivery.config_eligible_override.getValue() as any;
  }

  get requestTypeDisableRule(): string[] {
    return this.detailSTT.rpdRequestType
      ? this.configEligibleOverride[this.detailSTT.rpdRequestType]
      : [];
  }
}
